import styled from "styled-components";

export const Wrapper = styled("footer")(({ theme }) => ({
  backgroundColor: theme.palette.footerBg,
  color: theme.palette.textWhite,
  flexShrink: 0,
}));
